(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liquo-cyber-editorial"] && !Shopify.designMode) return;
  try {
    
function initLiquoCyber(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-lcy-advisor]');
  if (form) form.addEventListener('submit', function(event) {
    const phone = form.dataset.phone.replace(/\D/g, '');
    if (!phone) return;
    event.preventDefault();
    const moment = form.elements.moment.value;
    const reference = form.elements.reference.value.trim();
    const parts = [form.dataset.intro];
    if (moment) parts.push(form.dataset.momentLabel + ' ' + moment);
    if (reference) parts.push(form.dataset.referenceLabel + ' ' + reference);
    window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent(parts.join('\n')), '_blank', 'noopener,noreferrer');
  });
  const counter = root.querySelector('[data-lcy-countdown]');
  if (counter) {
    const end = Date.parse(counter.dataset.end);
    if (Number.isFinite(end)) {
      const units = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(key => [key, counter.querySelector('[data-clock-unit="' + key + '"]')]));
      const update = () => {
        const secondsLeft = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        counter.hidden = false;
        const values = { days: Math.floor(secondsLeft / 86400), hours: Math.floor(secondsLeft / 3600) % 24, minutes: Math.floor(secondsLeft / 60) % 60, seconds: secondsLeft % 60 };
        Object.entries(values).forEach(([key, value]) => { units[key].textContent = String(value).padStart(2, '0'); });
        if (secondsLeft === 0) {
          counter.querySelector('.lcy-clock-units').hidden = true;
          counter.querySelector('[data-clock-label]').hidden = true;
          counter.querySelector('[data-clock-ended]').hidden = false;
        }
        return secondsLeft > 0;
      };
      if (update()) {
        const timer = window.setInterval(() => { if (!root.isConnected || !update()) window.clearInterval(timer); }, 1000);
      }
    }
  }
}
document.querySelectorAll('[data-liquo-cyber]').forEach(initLiquoCyber);
document.addEventListener('shopify:section:load', function(event) { event.target.querySelectorAll('[data-liquo-cyber]').forEach(initLiquoCyber); });

  } catch(e) { console.error(e); }
})();
})();
